import { render, staticRenderFns } from "./DevicesConfirm.vue?vue&type=template&id=3b1752fb&scoped=true&"
import script from "./DevicesConfirm.vue?vue&type=script&lang=js&"
export * from "./DevicesConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DevicesConfirm.vue?vue&type=style&index=0&id=3b1752fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1752fb",
  null
  
)

export default component.exports